var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"mgpay",attrs:{"src":"https://files-prod-01.s3.sa-east-1.amazonaws.com/uploads/login/mgpay-login.jpg","alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }